export class BillableItem
{
    public id: number;
    public version: number;
    public rate: number;
    public code: string;
    public modifierCode: string;
    public modifierCode2: string;
    public modifierCode3: string;
    public diagnosisCode: string;
    public from: Date;
    public to: Date;
    public extensions: any;
    public billableId: number;
}
